function resetPw(user) {
  const { id } = user;
  return window.$http({
    url: `/api/v1/registration/reset-password/${id}`,
    method: 'put',
  });
}

export default resetPw;
